// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1dfCA","obliqueLineWrap":"membershipbadge_obliqueLineWrap__1z9G2","obliqueLine":"membershipbadge_obliqueLine__Qpf7F"};